"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskAuditLogList = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const useFindTaskAuditLogs_1 = require("../hooks/useFindTaskAuditLogs");
const Task_event_1 = require("../Task.event");
const TaskAuditLogListItem_1 = __importDefault(require("./TaskAuditLogListItem"));
const StyledList = (0, styled_components_1.default)(core_1.List) `
  padding-top: 0;
  padding-bottom: 0;
  .empty {
    padding: 16px;
  }
  .load-more {
    justify-content: center;
  }
`;
const TaskAuditLogList = props => {
    const { task } = props;
    const limit = 10;
    const taskIdRef = (0, react_1.useRef)(task.id);
    const [page, setPage] = (0, react_1.useState)(0);
    const [logs, setLogs] = (0, react_1.useState)([]);
    const { taskAuditLogList, isLoading, error, findAuditLogs } = (0, useFindTaskAuditLogs_1.useFindTaskAuditLogs)(task.id);
    const findAuditLogsWithParams = (0, react_1.useCallback)(() => {
        findAuditLogs({ page, limit });
    }, [page, limit, findAuditLogs]);
    const refresh = (0, react_1.useCallback)(() => {
        setLogs([]);
        // update page to 0, fetch if currently 0
        setPage(page => {
            page === 0 && findAuditLogsWithParams();
            return 0;
        });
    }, [findAuditLogsWithParams]);
    (0, react_1.useEffect)(() => {
        findAuditLogsWithParams();
    }, [findAuditLogsWithParams]);
    (0, react_1.useEffect)(() => {
        if (task.id !== taskIdRef.current) {
            taskIdRef.current = task.id;
            refresh();
        }
    }, [task, refresh]);
    // refresh on change status
    (0, react_1.useEffect)(() => {
        return Task_event_1.TaskEvent.handle(Task_event_1.TaskEventType.ChangeStatus, () => refresh());
    }, [refresh]);
    (0, react_1.useEffect)(() => {
        if (!(taskAuditLogList === null || taskAuditLogList === void 0 ? void 0 : taskAuditLogList.data)) {
            return;
        }
        setLogs(logs => {
            if (taskAuditLogList.page === 0) {
                logs = [];
            }
            const newLogs = taskAuditLogList.data.filter(newLog => !logs.some(log => log.id === newLog.id));
            // sort the list after appending statuses
            return logs.concat(newLogs).sort((a, b) => {
                return new Date(b.created).getTime() - new Date(a.created).getTime();
            });
        });
    }, [taskAuditLogList]);
    return (react_1.default.createElement(StyledList, null,
        isLoading && react_1.default.createElement(core_1.LinearProgress, null),
        error && react_1.default.createElement(lab_1.Alert, { severity: 'error' }, error.message),
        !isLoading && !error && logs.length === 0 && (react_1.default.createElement(core_1.ListItem, { className: 'empty' }, "No audit logs available.")),
        logs.map(log => (react_1.default.createElement(TaskAuditLogListItem_1.default, { log: log, key: log.id }))),
        taskAuditLogList && taskAuditLogList.total > (page + 1) * limit && (react_1.default.createElement(core_1.ListItem, { className: 'load-more' },
            react_1.default.createElement(core_1.Button, { color: 'primary', onClick: () => setPage(page + 1) }, "Load More")))));
};
exports.TaskAuditLogList = TaskAuditLogList;
exports.default = exports.TaskAuditLogList;
//# sourceMappingURL=TaskAuditLogList.js.map